<template>
    <div>
        <div class="card-body received-mail-container">
            <div class="d-flex mb-4">
                <div class="pl-2 pr-2 overflow-auto flex-grow-1 line-height-2">
                    <h5 v-if="email.from_name !== undefined" class="mb-0">
                        {{email.from_name}}
                    </h5>
                    <small v-if="email.from_name !== undefined" class="text-muted">
                        From: {{email.from}}
                    </small>
                    <h5 v-if="email.from_name === undefined" class="mb-0">
                        {{email.from}}
                    </h5>
                    <small class="text-muted">
                        To: {{email.to}}
                    </small>
                    <small v-if="email.cc" class="text-muted">
                        cc:{{email.cc}}
                    </small>
                    <small v-if="email.bcc" class="text-muted">
                        bcc:{{email.bcc}}
                    </small>
                    <div>
                        <a class="attachment" v-for="attachment in email.media" :href="attachment.url" target="_blank">
                            <small>{{attachment.file_name}}</small>
                        </a>
                    </div>
                </div>
                <div class="pr-2 line-height-2" style="min-width: 100px;">
                    <small class="text-muted">{{email.sent_at | datetime}}</small>
                </div>
                <div>
                    <div>
                        <el-dropdown trigger="click" @command="handleCommand">
                            <el-button size="mini">
                                <i class="mdi mdi-dots-horizontal"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="forwardEmail">Forward</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
            <div class="p-2 received-mail-content" v-html="safeEmailBody(email.body)" v-show="!showOriginal"></div>
            <div class="p-2 original-mail-content" v-show="showOriginal">
                <div class="original-iframe-container" v-show="showOriginal">
                    <div class="loader-container" v-if="loadingOriginal">
                        <div class="loader">
                            <svg class="circular" viewBox="25 25 50 50">
                                <circle
                                    class="path"
                                    cx="50"
                                    cy="50"
                                    r="20"
                                    fill="none"
                                    stroke-width="2"
                                    stroke-miterlimit="10"
                                />
                            </svg>
                        </div>
                    </div>
                    <iframe
                        id="original-email-iframe"
                        class="original-iframe"
                        gesture="media"
                        allow="encrypted-media"
                        :src="original"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
            <a href="#" v-if="!showOriginal && email.source_s3_key" class="show-original" @click.prevent="toggleOriginal">
                <i class="mdi mdi-chevron-down"></i> Show Original
            </a>
            <a href="#" v-if="showOriginal" class="show-original" @click.prevent="toggleOriginal">
                <i class="mdi mdi-chevron-up"></i> Collapse
            </a>
        </div>

    </div>
</template>

<script>
export default {
    props: ["email"],
    data () {
        return {
            original: undefined,
            showOriginal: false,
            loadingOriginal: false
        };
    },
    methods: {
        safeEmailBody (html) {
            let temp = document.createElement("div");
            temp.innerHTML = html;
            let elements = temp.getElementsByTagName("style");
            if (elements.length > 0) {
                while (elements[0])
                    elements[0].parentNode.removeChild(elements[0]);
            }
            return temp.innerHTML;
        },
        toggleOriginal () {
            if (this.original !== undefined) {
                this.showOriginal = !this.showOriginal;
                this.original = undefined;
                return;
            }

            this.loadingOriginal = true;
            this.original = "/emails/" + this.email.id + "/original";
            this.showOriginal = true;

            let self = this;
            document.getElementById("original-email-iframe").onload = function () {
                self.loadingOriginal = false;
            };
        },
        handleCommand(command) {
            if (command === 'forwardEmail') {
                this.$emit('forward-email', this.email.id);
            }
        }
    }
};
</script>

<style>
    .attachment {
        background: #f3f7f8;
        padding: 3px 4px;
        margin-right: 5px;
        border-radius: 5px;
        color: #33b5e5;
        display: inline-block;
    }
    .original-iframe-container {
        position: relative;
        overflow: hidden;
        padding-top: 56.25%;
    }
    .original-iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
    .received-mail-container {
        border-bottom: 1px solid #f2f7f8;
        border-right: 3px solid #55ce63;
    }
    .show-original {
        font-size: 12px;
        font-weight: 500;
        padding: 2px;
        color: #33b5e5;
        margin-left: 10px;
    }
    .original-mail-content {
        margin-left: 20px;
    }
    .received-mail-content {
        white-space: pre-wrap;
    }
    blockquote {
        padding: 15px;
        border: none;
        border-left: #efefef 3px solid;
    }
</style>
